import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function TermsAndConditions() {
  useEffect(() => {
    // Create and append the OneTrust script
    const script = document.createElement('script');
    script.src = 'https://privacyportal-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js';
    script.type = 'text/javascript';
    script.charset = 'UTF-8';
    script.id = 'otprivacy-notice-script';
    script.setAttribute('settings', 'eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vZmxsci1wcml2YWN5Lm15Lm9uZXRydXN0LmNvbS9yZXF1ZXN0L3YxL3ByaXZhY3lOb3RpY2VzL3N0YXRzL3ZpZXdzIiwiY29udGVudEFwaVVybCI6Imh0dHBzOi8vZmxsci1wcml2YWN5Lm15Lm9uZXRydXN0LmNvbS9yZXF1ZXN0L3YxL2VudGVycHJpc2Vwb2xpY3kvZGlnaXRhbHBvbGljeS9jb250ZW50IiwibWV0YWRhdGFBcGlVcmwiOiJodHRwczovL2ZsbHItcHJpdmFjeS5teS5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9lbnRlcnByaXNlcG9saWN5L2RpZ2l0YWxwb2xpY3kvbWV0YS1kYXRhIn0=');

    document.body.appendChild(script);

    // Create and append the initialization script
    const initScript = document.createElement('script');
    initScript.type = 'text/javascript';
    initScript.charset = 'UTF-8';
    initScript.text = `
      // To ensure external settings are loaded, use the Initialized promise:
      OneTrust.NoticeApi.Initialized.then(function() {
        OneTrust.NoticeApi.LoadNotices(["https://privacyportal-cdn.onetrust.com/storage-container/73cb21c4-9737-45b0-ba87-528432c7bbca/privacy-notices/7c4cd6a0-601c-4376-8ba3-35ce48a25e96/published/privacynotice.json"]);
      });
    `;

    // Wait for the first script to load before adding the initialization script
    script.onload = () => {
      document.body.appendChild(initScript);
    };

    return () => {
      // Cleanup function to remove scripts when component unmounts
      const scriptElement = document.getElementById('otprivacy-notice-script');
      if (scriptElement) {
        scriptElement.remove();
      }
      if (initScript.parentNode) {
        initScript.remove();
      }
      
      // Clear any notice content
      const noticeElement = document.getElementById('otnotice-7c4cd6a0-601c-4376-8ba3-35ce48a25e96');
      if (noticeElement) {
        noticeElement.innerHTML = '';
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <Link
            to="/login"
            className="inline-flex items-center text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 transition-colors duration-200"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Sign In
          </Link>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 transition-colors duration-200">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6 transition-colors duration-200">
            Terms and Conditions
          </h1>

          {/* Language Drop-down element */}
          <div className="ot-privacy-notice-language-dropdown-container mb-4"></div>

          {/* Container for the Privacy Notice */}
          <div 
            id="otnotice-7c4cd6a0-601c-4376-8ba3-35ce48a25e96" 
            className="otnotice"
          ></div>
        </div>
      </div>
    </div>
  );
}